import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransferReviewPage, { getDefaultPageData } from "components/pages/TransferReviewPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersReviewTransfer
 * @returns {React.Component}
 * @description The capture component for the review transfers page with the 
 * from, to, amount and description values entered
 */
export default function CaptureTransfersReviewTransfer(props) {
    // Initialize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // updating the from, to, amount and description properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .update([ "transfer", "description" ], "Sample")
        .submit();

    // Return the TransferReviewPage passing the data variable
    return <TransferReviewPage data={ data } />
}